export default {
  title: 'Modifica ordine',
  product_info: {
    earn_points: 'Guadagna {{points}} punti',
  },
};
